import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { FormGroup, Row, Button, Label } from 'reactstrap';

import styles from './styles.module.scss';

import { treatmentResultRecordsForm } from '../../../../constants/FormConstants';
import * as Validators from '../../../../util/Validators';
import {
  isExportAndLogs,
  isBreakBulkJobType,
  isBreakBulkOrExportOfLogsAndMethylBromide,
  isMBLogsInHold,
  isImportOrExportAndContainer,
  isImportOrExportContainerAndMethylBromide,
  isExportOtherMBApples,
} from '../../../../util/JobTypeHelper';
import {
  isMethylBromide,
  isVaporPhos,
  isAlPNonVessel,
  isEthylFormate,
  isSulfurylFlouride,
  isCallington1Shot,
  isHeat,
} from '../../../../util/TreatmentTypeHelper';

import RenderField from '../../../fields/RenderField';
import CheckboxField from '../../../fields/CheckboxField';
import SearchableSelect from '../../../fields/SearchableSelect';
import DatePickerField from '../../../fields/DatePickerField';
import RecaptureReadingsFieldArray from '../TreatmentResultRecordsMonitoringSection/RecaptureReadingsFieldArray';
import moment from 'moment';

const propTypes = {
  technicians: PropTypes.array.isRequired,
  canEditJob: PropTypes.bool,
  jobType: PropTypes.object.isRequired,
  treatmentType: PropTypes.string,
  actions: PropTypes.object.isRequired,
  showNoEndPhaseMessage: PropTypes.bool,
  sectionTouched: PropTypes.bool,
};

class TreatmentResultRecordsUncoveringSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
    };
  }

  onEditing(isEditing) {
    this.setState({ isEditing });
  }
  componentDidMount() {
    const {
      actions,
      treatmentType,
      currentTreatmentResultRecord,
      jobType,
      currentJob,
    } = this.props;
    const commodity = currentJob.treatmentTypeDetails.commodity;
    const standardId = currentJob.treatmentDetails.standardId;
    if (this.isPassedByDefault()) {
      actions.changeFieldValue(treatmentResultRecordsForm, 'passed', true);
    }
    if (isExportOtherMBApples(jobType, treatmentType, commodity, standardId)) {
      console.log(currentTreatmentResultRecord.concentrationReadingItem);
      if (
        currentTreatmentResultRecord &&
        currentTreatmentResultRecord.concentrationReadingChamberItem
      ) {
        var endPhaseList =
          currentTreatmentResultRecord.concentrationReadingChamberItem.filter(
            (cri) => cri.interval === 3,
          );
        var endTime = endPhaseList[0];
        if (endTime) {
          actions.changeFieldValue(
            treatmentResultRecordsForm,
            'endDate',
            endTime.readingDateTime,
          );
        }
      }
    }
  }

  isPassedByDefault() {
    const { jobType, treatmentType } = this.props;
    return isMethylBromide(treatmentType) && isBreakBulkJobType(jobType);
  }
  getFumoReadingTimes = (currentTreatmentResultRecord) => {
    const { jobType, treatmentType } = this.props;
    var efReadings = currentTreatmentResultRecord.efConcentrationReadingItem
      ? currentTreatmentResultRecord.efConcentrationReadingItem.filter(Boolean)
      : null;
    if (efReadings == undefined || efReadings == null) {
      efReadings = currentTreatmentResultRecord.efConcentrationReadingItem;
    }
    if (isSulfurylFlouride(treatmentType)) {
      efReadings = currentTreatmentResultRecord.concentrationReadingItem;
    }
    var initialPhase = efReadings ? efReadings.find((x) => x.phase == 0) : null;
    var finalReadingsEF = efReadings
      ? efReadings.find((x) => x.phase == 2)
      : null;
    var initialReadingValues = {
      readingValue: 'no value',
      readTime: 'no value',
    };
    var finalReadingValues = { readingValue: 'no value', readTime: 'no value' };
    if (isEthylFormate(treatmentType) && initialPhase && finalReadingsEF) {
      initialReadingValues = this.getStartFumoReadings(initialPhase);
      finalReadingValues = this.getReadings(finalReadingsEF);
    }
    if (isSulfurylFlouride(treatmentType) && initialPhase && finalReadingsEF) {
      initialReadingValues = this.getStartFumoReadings(initialPhase);
      finalReadingValues = this.getReadings(finalReadingsEF);
    }
    return { initialReadingValues, finalReadingValues };
  };

  getReadings = (initialPhase) => {
    var lowestReadingLocation = '';
    var lowestReadingDateTime;
    const { treatmentType } = this.props;
    var readingList = [];
    if (initialPhase != null) {
      if ((initialPhase.frontEf != null) | (initialPhase.frontEf != undefined))
        readingList = [...readingList, initialPhase.frontEf];
      if (
        (initialPhase.middleEf != null) |
        (initialPhase.middleEf != undefined)
      )
        readingList = [...readingList, initialPhase.middleEf];
      if ((initialPhase.backEf != null) | (initialPhase.backEf != undefined))
        readingList = [...readingList, initialPhase.backEf];
    }
    if (isSulfurylFlouride(treatmentType) && initialPhase != null) {
      if (
        (initialPhase.reading1 != null) |
        (initialPhase.reading1 != undefined)
      )
        readingList = [...readingList, initialPhase.reading1];
      if (
        (initialPhase.reading2 != null) |
        (initialPhase.reading2 != undefined)
      )
        readingList = [...readingList, initialPhase.reading2];
      if (
        (initialPhase.reading3 != null) |
        (initialPhase.reading3 != undefined)
      )
        readingList = [...readingList, initialPhase.reading3];
    }
    var lowestReading = Math.min(...readingList);
    return {
      readingValue: lowestReading,
      readTime: moment(initialPhase.readingDateTime),
    };
  };
  getStartFumoReadings = (initialPhase) => {
    const { treatmentType } = this.props;
    var readingList = [];
    if (isEthylFormate(treatmentType) && initialPhase != null) {
      if ((initialPhase.frontEf != null) | (initialPhase.frontEf != undefined))
        readingList = [...readingList, initialPhase.frontEf];
      if (
        (initialPhase.middleEf != null) |
        (initialPhase.middleEf != undefined)
      )
        readingList = [...readingList, initialPhase.middleEf];
      if ((initialPhase.backEf != null) | (initialPhase.backEf != undefined))
        readingList = [...readingList, initialPhase.backEf];
    }
    if (isSulfurylFlouride(treatmentType) && initialPhase != null) {
      if (
        (initialPhase.reading1 != null) |
        (initialPhase.reading1 != undefined)
      )
        readingList = [...readingList, initialPhase.reading1];
      if (
        (initialPhase.reading2 != null) |
        (initialPhase.reading2 != undefined)
      )
        readingList = [...readingList, initialPhase.reading2];
      if ((initialPhase.rading3 != null) | (initialPhase.reading3 != undefined))
        readingList = [...readingList, initialPhase.reading3];
    }

    var lowestReading = Math.min(...readingList);

    return {
      readingValue: lowestReading,
      readTime: moment(initialPhase.readingDateTime),
    };
  };
  getFumoTime = (startDatetime, endDateTime) => {
    const { treatmentType } = this.props;
    /*const timeDifference = endDateTime - startDatetime;
      const secondsDifference = timeDifference / 1000;
      const hours = Math.floor((secondsDifference % (3600 * 24)) / 3600);
      const minutes = Math.floor((secondsDifference % 3600) / 60)/100;
      const totDif = hours+minutes
      return totDif;*/
    const timeDifference = endDateTime - startDatetime; //time in millisecs
    const duration = moment.duration(timeDifference);
    const totalHours = duration.days() * 24 + duration.hours();
    return totalHours;
  };
  getCTValue = (lowestValues, numOfHours) => {
    var val = 0;
    if (
      lowestValues != undefined &&
      lowestValues.finalReadingValues != undefined &&
      numOfHours != undefined
    ) {
      val =
        Math.round(
          (((lowestValues.initialReadingValues.readingValue +
            lowestValues.finalReadingValues.readingValue) /
            2) *
            numOfHours +
            Number.EPSILON) *
            100,
        ) / 100;
    }
    const { actions } = this.props;

    actions.changeFieldValue(treatmentResultRecordsForm, 'CTValue', val);
  };
  updateCTValue = (lowestValues, numOfHours) => {
    const { actions } = this.props;
    var ctVal = lowestValues
      ? Math.round(
          (((lowestValues.initialReadingValues.readingValue +
            lowestValues.finalReadingValues.readingValue) /
            2) *
            numOfHours +
            Number.EPSILON) *
            100,
        ) / 100
      : 0;
    actions.changeFieldValue(treatmentResultRecordsForm, 'CTValue', ctVal);
  };

  render() {
    const {
      technicians,
      canEditJob,
      jobType,
      treatmentType,
      showNoEndPhaseMessage,
      sectionTouched,
      jobId,
      currentJob,
      currentTreatmentResultRecord,
    } = this.props;
    const commodity = currentJob.treatmentTypeDetails.commodity;
    const standardId = currentJob.treatmentDetails.standardId;
    const treatmentTypeId = currentJob.treatmentDetails.treatmentTypeId;
    const isCoveredContainer = null; //currentJob.treatmentTypeDetails.covered?currentJob.treatmentTypeDetails.covered:null
    var percentage = [
      { name: 80, id: '80' },
      { name: 90, id: '90' },
    ];
    // var percentageChamber = [{name:80,id:'80'}]
    var isoTanksLogs = [
      { name: 'Tank Not Used', id: 0 },
      { name: 'ISO Tank 1', id: 1 },
      { name: 'ISO Tank 2', id: 2 },
      { name: 'ISO Tank 3', id: 3 },
      { name: 'ISO Tank 4', id: 4 },
    ];
    const validationOn = sectionTouched;
    const isApples = isExportOtherMBApples(
      jobType,
      treatmentTypeId,
      commodity,
      standardId,
    );
    var lowestValues =
      isEthylFormate(treatmentType) &&
      currentTreatmentResultRecord.efConcentrationReadingItem != null &&
      currentTreatmentResultRecord.efConcentrationReadingItem.length > 0
        ? this.getFumoReadingTimes(currentTreatmentResultRecord)
        : 0;
    if (isSulfurylFlouride(treatmentType)) {
      lowestValues = isSulfurylFlouride(treatmentType)
        ? this.getFumoReadingTimes(currentTreatmentResultRecord)
        : 0;
    }
    var numOfHours =
      (isSulfurylFlouride(treatmentType) || isEthylFormate(treatmentType)) &&
      lowestValues != null &&
      lowestValues.finalReadingValues != undefined &&
      lowestValues.finalReadingValues.readTime != 'no value'
        ? this.getFumoTime(
            lowestValues.initialReadingValues.readTime,
            lowestValues.finalReadingValues.readTime,
          )
        : 0;
    var ctVal =
      (isSulfurylFlouride(treatmentType)
        ? this.updateCTValue(lowestValues, numOfHours)
        : isEthylFormate(treatmentType)) &&
      lowestValues != undefined &&
      numOfHours != undefined
        ? this.getCTValue(lowestValues, numOfHours)
        : null;

    return (
      <div>
        {showNoEndPhaseMessage &&
          !isSulfurylFlouride(treatmentType) &&
          !isEthylFormate(treatmentType) && (
            <p className={styles.errorNote}>
              A monitoring reading for <strong>end</strong> phase needs to be
              entered before submitting uncovering details.
            </p>
          )}
        <fieldset disabled={!canEditJob && 'disabled'}>
          {isSulfurylFlouride(treatmentType) ||
          isEthylFormate(treatmentType) ? (
            <p>
              CT Calulation Formula : ((Lowest Initial reading + lowest final
              reading) ÷ 2 readings) x number of hours
            </p>
          ) : null}

          <Row>
            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-3">
                <Label htmlFor="treatmentresultrecords">Lowest Initial</Label>
                <input
                  className="form-control-plaintext"
                  placeholder="No value"
                  type="text"
                  value={
                    lowestValues
                      ? lowestValues.initialReadingValues.readingValue
                      : null
                  }
                  readOnly
                />
              </FormGroup>
            ) : null}
            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-3">
                <Label htmlFor="treatmentresultrecords">
                  Start of Fumigation Time
                </Label>
                <input
                  className="form-control-plaintext"
                  placeholder="No value"
                  type="text"
                  value={
                    lowestValues
                      ? moment(
                          lowestValues.initialReadingValues.readTime,
                        ).format('HH:mm')
                      : null
                  }
                  readOnly
                />
              </FormGroup>
            ) : null}

            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-3">
                <Label htmlFor="treatmentresultrecords">
                  Lowest Final Time
                </Label>
                <input
                  className="form-control-plaintext"
                  placeholder="No value"
                  type="text"
                  value={
                    lowestValues
                      ? moment(lowestValues.finalReadingValues.readTime).format(
                          'HH:mm',
                        )
                      : null
                  } //value={lowestValues?lowestValues.finalReadingValues.readingValue:null}
                  readOnly
                />
              </FormGroup>
            ) : null}
            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-3">
                <Label htmlFor="treatmentresultrecords">
                  Inital + Final{' '}
                  {lowestValues
                    ? `(${lowestValues.initialReadingValues.readingValue} + ${lowestValues.finalReadingValues.readingValue})`
                    : null}
                </Label>
                <input
                  className="form-control-plaintext"
                  placeholder="No value"
                  type="text"
                  value={
                    lowestValues
                      ? lowestValues.initialReadingValues.readingValue +
                        lowestValues.finalReadingValues.readingValue
                      : null
                  }
                  readOnly
                />
              </FormGroup>
            ) : null}

            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-3">
                <Label htmlFor="treatmentresultrecords">
                  CT Value
                  {lowestValues
                    ? `((${lowestValues.initialReadingValues.readingValue} +
                       ${lowestValues.finalReadingValues.readingValue})/2)*${numOfHours}`
                    : null}
                </Label>
                <input
                  className="form-control-plaintext"
                  placeholder="No value"
                  type="text"
                  value={
                    lowestValues
                      ? Math.round(
                          (((lowestValues.initialReadingValues.readingValue +
                            lowestValues.finalReadingValues.readingValue) /
                            2) *
                            numOfHours +
                            Number.EPSILON) *
                            100,
                        ) / 100
                      : null
                  }
                />
              </FormGroup>
            ) : null}

            {isExportAndLogs(jobType) ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="yardNumber"
                  label={
                    jobType.name === 'MB Logs In Hold' ? 'Hold #' : 'Yard #'
                  }
                  component={RenderField}
                  type="text"
                  readOnly
                />
              </FormGroup>
            ) : null}
            {isBreakBulkJobType(jobType) ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="stackNumber"
                  label="Stack #"
                  component={RenderField}
                  type="text"
                  readOnly
                />
              </FormGroup>
            ) : null}
            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ? (
              <FormGroup className="col-lg-6"></FormGroup>
            ) : null}
            {!isImportOrExportAndContainer(jobType) ||
            isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ||
            isApples ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="uncoveringTechnicianId"
                  label={
                    !isMBLogsInHold(jobType) &&
                    !isSulfurylFlouride(treatmentType) &&
                    !isEthylFormate(treatmentType)
                      ? 'Technician *'
                      : 'Venting Technician'
                  }
                  component={SearchableSelect}
                  placeholder="Please select a technician"
                  options={technicians}
                  valueKey="id"
                  labelKey="name"
                  validate={validationOn ? Validators.required : undefined}
                />
              </FormGroup>
            ) : null}
            {isApples ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="endDate"
                  label="End Date *"
                  component={DatePickerField}
                  defaultToEmpty
                  showTimeSelect
                  type="text"
                  disabled={true}
                  placeholder="Enter End Date"
                  validate={
                    validationOn
                      ? [Validators.isValidDateAndTime, Validators.required]
                      : undefined
                  }
                  timeIntervals={1}
                />
              </FormGroup>
            ) : (
              !(
                isMethylBromide(treatmentType) ||
                ((isSulfurylFlouride(treatmentType) ||
                  isEthylFormate(treatmentType)) &&
                  (isBreakBulkJobType(jobType) || !isExportAndLogs(jobType)))
              ) && (
                <FormGroup className="col-lg-6">
                  <Field
                    name="endDate"
                    label="End Date *"
                    component={DatePickerField}
                    defaultToEmpty
                    showTimeSelect
                    type="text"
                    placeholder="Enter End Date"
                    validate={
                      validationOn
                        ? [Validators.isValidDateAndTime, Validators.required]
                        : undefined
                    }
                    timeIntervals={1}
                  />
                </FormGroup>
              )
            )}
            {isCallington1Shot(treatmentType) ? null : (
              <FormGroup className="col-lg-6">
                <Field
                  name="actualTemperature"
                  label={
                    isEthylFormate(treatmentType) || isImportOrExportAndContainer(jobType) 
                      ? 'Min. Temperture *'
                      : 'Actual Temperature *'
                  }
                  component={RenderField}
                  type="number"
                  placeholder={
                    isEthylFormate(treatmentType)
                      ? 'Enter min Temperature'
                      : 'Enter the Actual Temperature'
                  }
                  validate={
                    validationOn
                      ? [Validators.number, Validators.required]
                      : undefined
                  }
                />
              </FormGroup>
            )}
            {isMethylBromide(treatmentType) &&
            isImportOrExportAndContainer(jobType) ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="tempFactor"
                  label={'Temp Correction Factor *'}
                  component={RenderField}
                  type="text"
                  inputMode="decimal"
                  placeholder={'Enter Temp Factor'}
                  validate={[Validators.number, Validators.required]}
                />
              </FormGroup>
            ) : null}
            {(!isHeat(treatmentType) && isMethylBromide(treatmentType)) ||
            isEthylFormate(treatmentType) ||
            isSulfurylFlouride(treatmentType) ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="ventStartDateTime"
                  label={'Vent Start Date/Time'}
                  component={DatePickerField}
                  defaultToEmpty
                  showTimeSelect
                  type="text"
                  placeholder="Enter Vent Date/Time"
                  timeIntervals={1}
                />
              </FormGroup>
            ) : null}
            {isEthylFormate(treatmentType) ||
            isSulfurylFlouride(treatmentType) ||
            isBreakBulkOrExportOfLogsAndMethylBromide(jobType, treatmentType) ||
            isMBLogsInHold(jobType) ||
            isImportOrExportAndContainer(jobType) ||
            isApples ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="ventDateTime"
                  label={
                    !isHeat(treatmentType)
                      ? 'Vent End Date/Time'
                      : 'Vent Date/Time'
                  }
                  component={DatePickerField}
                  defaultToEmpty
                  showTimeSelect
                  type="text"
                  placeholder="Enter Vent Date/Time"
                  // validate = {Validators.checkEndTime}
                  validate={[Validators.requiredTrue, Validators.checkEndTime]}
                  timeIntervals={1}
                />
              </FormGroup>
            ) : null}
            {isSulfurylFlouride(treatmentType) ||
            isBreakBulkOrExportOfLogsAndMethylBromide(jobType, treatmentType) ||
            (isImportOrExportAndContainer(jobType) &&
              !isEthylFormate(treatmentType)) ||
            isApples ? (
              <FormGroup className="col-lg-6">
                <Field
                  name="unintentionalRelease"
                  label="Unintentional Release"
                  component={SearchableSelect}
                  options={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ]}
                  valueKey={'value'}
                  labelKey={'label'}
                />
              </FormGroup>
            ) : null}

            {isMethylBromide(currentJob.treatmentDetails.treatmentTypeId) ||
            isEthylFormate(currentJob.treatmentDetails.treatmentTypeId) ? (
              <FormGroup className="col-md-4">
                <Field
                  name="twareading"
                  label="TWA Reading *"
                  component={RenderField}
                  type="text"
                  disabled
                  validate={Validators.mandatoryList}
                  placeholder="TLV/TWA Readings)"
                />
              </FormGroup>
            ) : null}
            {isSulfurylFlouride(treatmentType) ||
            isEthylFormate(treatmentType) ||
            isBreakBulkOrExportOfLogsAndMethylBromide(jobType, treatmentType) ||
            isApples ? (
              <FormGroup className="col-lg-12">
                <Field
                  name="uncoveringComments"
                  label="Comments"
                  component={RenderField}
                  type="textarea"
                />
              </FormGroup>
            ) : null}
            <FormGroup className="col-lg-12"></FormGroup>
            <FormGroup className="col-lg-6 align-self-center">
              <Field
                name="passed"
                label="Fumigation Pass"
                component={CheckboxField}
                hidden={this.isPassedByDefault()}
              />
            </FormGroup>
            {isBreakBulkOrExportOfLogsAndMethylBromide(
              jobType,
              treatmentType,
            ) ? (
              <FormGroup className="col-lg-5">
                <Field
                  name="isoTankLogs"
                  label={'ISO Tank *'}
                  component={SearchableSelect}
                  placeholder="Please select ISO Tank used"
                  options={isoTanksLogs}
                  valueKey="name"
                  labelKey="name"
                />
              </FormGroup>
            ) : null}
            {isMethylBromide(treatmentType) ? (
              <FormGroup className="col-lg-12"></FormGroup>
            ) : null}
            {isImportOrExportContainerAndMethylBromide(
              jobType,
              treatmentType,
            ) || isApples ? (
              <FormGroup className="col-lg-4 align-self-center font-weight-bold">
                Recapture
              </FormGroup>
            ) : null}
            {isImportOrExportContainerAndMethylBromide(
              jobType,
              treatmentType,
            ) ? (
              <FormGroup className="col-md-4">
                <Field
                  name="recapturePercentage"
                  label={'Recapture target %'}
                  component={SearchableSelect}
                  options={percentage}
                  placeholder={'Please select recapture target'}
                  valueKey="id"
                  labelKey="name"
                />
              </FormGroup>
            ) : isApples ||
              isBreakBulkOrExportOfLogsAndMethylBromide(
                jobType,
                treatmentType,
              ) ? (
              <FormGroup className="col-md-4">
                <Field
                  name="recapturePercentage"
                  label={'Recapture target 90 %'}
                  component={RenderField}
                  readOnly={true}
                />
              </FormGroup>
            ) : null}
            {isBreakBulkOrExportOfLogsAndMethylBromide(
              jobType,
              treatmentType,
            ) ? (
              <FormGroup className="col-md-4"></FormGroup>
            ) : null}
            {isApples ||
            isImportOrExportContainerAndMethylBromide(jobType, treatmentType) ||
            isBreakBulkOrExportOfLogsAndMethylBromide(
              jobType,
              treatmentType,
            ) ? (
              <FieldArray
                name="recaptureReadingItem"
                component={RecaptureReadingsFieldArray}
                readOnly={!canEditJob}
                jobId={jobId}
                job={currentJob}
                onEditing={this.onEditing.bind(this)}
                currentTreatmentResultRecord={currentTreatmentResultRecord}
              />
            ) : null}
            <FormGroup className="col-12">
              <Button
                type="submit"
                className="mt-3"
                color="primary"
                disabled={showNoEndPhaseMessage}
              >
                Save
              </Button>
            </FormGroup>
          </Row>
        </fieldset>
      </div>
    );
  }
}

TreatmentResultRecordsUncoveringSection.propTypes = propTypes;

export default TreatmentResultRecordsUncoveringSection;
